module.exports = __webpack_public_path__ + "img/rocketmatter.94d9ba64.jpg";